export const suitesData = () => {
  return [
    {
      class: "party",
      // description:
      //   "Scale up the fun and bring everyone! The Party Suites of Globe Life Field are adaptable to your needs. Allow us to open up the floor plan to accommodate hundreds at a time or transform the room into smaller, more cozy spaces. The choice is yours.<br><br>Interested in purchasing individual tickets in a suite? You can do that right here! Just click the link below to purchase tickets in Party Suites 201 or 202. Your ticket will include buffet, soda and water. For more information click <a href='https://mktg.mlbstatic.com/rangers/documents/y2023/23_PartySuites.pdf' target='blank'>here</a>. To see Party Suites 201 and 202 on a map, click <a href='https://mktg.mlbstatic.com/rangers/documents/y2023/tex-ps201-202-map.pdf' target='_blank'>here</a>.",
      description:
        "Scale up the fun and bring everyone! The Party Suites of Globe Life Field are adaptable to your needs. Allow us to open up the floor plan to accommodate hundreds at a time or transform the room into smaller, more cozy spaces. The choice is yours.",
      repButton: true,
      // buyButton:
      //   "https://mlb.tickets.com/schedule/?agency=MLB_MPV&orgid=3#/sales_group_code;salesGroupId=2705",
      suites: [
        {
          title: "<span>lower</span> party suites",
          slider: [
            require("@/assets/images/SuiteRentals/PartySuites/Lower/party_lower_1.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Lower/party_lower_2.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Lower/party_lower_3.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Lower/party_lower_4.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Lower/party_lower_5.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Lower/party_lower_6.jpg"),
          ],
          info: [
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_pin-location.svg"),
              description: "lower concourse",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_ticket.svg"),
              description: "40-170 tickets",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_dollar-sign.svg"),
              description: "starting at $160/person*",
            },
          ],
          capacities: {
            prefix: "first",
            content: [
              {
                suite: "ps",
                number: 101,
                info: "PS 101 + 102 expanded up to 100",
                capacity: 50,
              },
              {
                suite: "ps",
                number: 102,
                info: "PS 101 + 102 expanded up to 100",
                capacity: 50,
              },
              {
                suite: "ps",
                number: 103,
                info: "PS 103 + 104 expanded up to 170",
                capacity: 90,
              },
              {
                suite: "ps",
                number: 104,
                info: "PS 103 + 104 expanded up to 170",
                capacity: 80,
              },
              {
                suite: "ps",
                number: 105,
                info: "PS 105 + 106 expanded up to 100",
                capacity: 50,
              },
              {
                suite: "ps",
                number: 106,
                info: "PS 105 + 106 expanded up to 100",
                capacity: 50,
              },
              {
                suite: "ps",
                number: 107,
                info: "PS 107 + 108 expanded up to 90",
                capacity: 50,
              },
              {
                suite: "ps",
                number: 108,
                info: "PS 107 + 108 expanded up to 90",
                capacity: 40,
              },
            ],
          },
        },
        {
          title: "<span>upper</span> party suites",
          slider: [
            require("@/assets/images/SuiteRentals/PartySuites/Upper/party_upper_1.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Upper/party_upper_2.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Upper/party_upper_3.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Upper/party_upper_4.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Upper/party_upper_5.jpg"),
            require("@/assets/images/SuiteRentals/PartySuites/Upper/party_upper_6.jpg"),
          ],
          info: [
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_pin-location.svg"),
              description: "Bailey & Galyen Law Suite Concourse",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_ticket.svg"),
              description: "50-300 tickets",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_dollar-sign.svg"),
              description: "starting at $155/person*",
            },
          ],
          capacities: {
            prefix: "second",
            content: [
              {
                suite: "ps",
                number: 201,
                info: "PS 201 + 202 expanded up to 100",
                capacity: 50,
              },
              {
                suite: "ps",
                number: 202,
                info: "PS 201 + 202 expanded up to 100",
                capacity: 50,
              },
              {
                suite: "ps",
                number: 205,
                info: "PS 205 + 206 + 207 + 208 expanded up to 300",
                capacity: "60-80",
              },
              {
                suite: "ps",
                number: 206,
                info: "PS 205 + 206 + 207 + 208 expanded up to 300",
                capacity: "60-75",
              },
              {
                suite: "ps",
                number: 207,
                info: "PS 205 + 206 + 207 + 208 expanded up to 300",
                capacity: "60-75",
              },
              {
                suite: "ps",
                number: 208,
                info: "PS 205 + 206 + 207 + 208 expanded up to 300",
                capacity: "60-75",
              },
            ],
          },
        },
      ],
      accordion: [
        // {
        //   icon: require("@/assets/icons/Benefits/icon_blue-big_pin-location.svg"),
        //   title: "suite location",
        //   description: "See where the Party Suites are located",
        //   image: require("@/assets/images/SuiteLocations/map_suite-locations_party.svg"),
        //   class: "party",
        // },
        {
          icon: require("@/assets/icons/icon_magnifying-glass.svg"),
          title: "compare suites",
          description: "Find the suite type that's right for you.",
          class: "party",
          inside: [
            {
              title: "party suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower & upper concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "40-300 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  // text: "$600 food & beverage package <span>(rent 2 or more conjoining suites to be eligible for package choices)</span>",
                  text: "Food & beverage package",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $150/person*",
                },
              ],
            },
            {
              title: "classic suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20-40 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "private restroom",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  // text: "$600 food & beverage credit <span>(20 or 40 person suite type, respectively)</span>",
                  text: "$600 food & beverage credit <u>or</u> package, based on suite size",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $225/person*",
                },
              ],
            },
            {
              title: "hall of fame suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20+ tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit <span>(rent 2 or more conjoining suites to be eligible for package choices)</span>",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $200/person*",
                },
              ],
            },
            {
              title: "legacy suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "18-30 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$800 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      class: "classic",
      description:
        "The most “traditional” suite offering at Globe Life Field. Spacious and inviting, you'll appreciate the attention to flow and detail of the <span>Classic Suites</span>, including the range of finishes from leather to metal.<br><br>Located on an exclusive concourse dedicated to suites, your Classic Suite will feel private and catered to your group’s needs. Each Classic Suite features a private restroom and wider ballpark seats that pair comfort with luxury.",
      // buyButton:
      //   "https://mlb.tickets.com/schedule/?agency=MLB_MPV&orgid=3#/sales_group_code;salesGroupId=2705",
      repButton: true,
      suites: [
        {
          title: "<span>20-Person</span> Classic Suites",
          slider: [
            require("@/assets/images/SuiteRentals/ClassicSuites/20person/classic_rental20_1.jpg"),
            require("@/assets/images/SuiteRentals/ClassicSuites/20person/classic_rental20_2.jpg"),
            require("@/assets/images/SuiteRentals/ClassicSuites/20person/classic_rental20_3.jpg"),
            require("@/assets/images/SuiteRentals/ClassicSuites/20person/classic_rental20_4.jpg"),
            require("@/assets/images/SuiteRentals/ClassicSuites/20person/classic_rental20_5.jpg"),
          ],
          info: [
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_pin-location.svg"),
              description: "Bailey & Galyen law suite level",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_ticket.svg"),
              description: "20 tickets",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_ticket.svg"),
              description: "private restroom",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_dollar-sign.svg"),
              description: "starting at $250/person*",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue_fork-knife.svg"),
              description: "$600 food & beverage credit",
            },
          ],
        },
        {
          title: "<span>40-Person</span> Classic Suites",
          slider: [
            require("@/assets/images/SuiteRentals/ClassicSuites/40person/classic_rental40_1.jpg"),
            require("@/assets/images/SuiteRentals/ClassicSuites/40person/classic_rental40_2.jpg"),
            require("@/assets/images/SuiteRentals/ClassicSuites/40person/classic_rental40_3.jpg"),
            require("@/assets/images/SuiteRentals/ClassicSuites/40person/classic_rental40_4.jpg"),
            require("@/assets/images/SuiteRentals/ClassicSuites/40person/classic_rental40_5.jpg"),
          ],
          info: [
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_pin-location.svg"),
              description: "Bailey & Galyen law suite level",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_ticket.svg"),
              description: "40 tickets",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_ticket.svg"),
              description: "private restroom",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_dollar-sign.svg"),
              description: "starting at $225/person*",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue_fork-knife.svg"),
              description: "food & beverage package",
            },
          ],
        },
      ],
      accordion: [
        // {
        //   icon: require("@/assets/icons/Benefits/icon_blue-big_pin-location.svg"),
        //   title: "suite location",
        //   description: "See where the Classic Suites are located",
        //   image: require("@/assets/images/SuiteLocations/map_suite-locations_classic-rentals.jpg"),
        //   class: "classic",
        // },
        {
          icon: require("@/assets/icons/icon_magnifying-glass.svg"),
          title: "compare suites",
          description: "Find the suite type that’s right for you.",
          class: "classic",
          inside: [
            {
              title: "party suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower & upper concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "40-300 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  // text: "$600 food & beverage credit <u>or</u> package <span>(rent 2 or more conjoining suites to be eligible for package choices)</span>",
                  text: "Food & beverage package",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $150/person*",
                },
              ],
            },
            {
              title: "classic suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20-40 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "private restroom",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  // text: "$600 food & beverage credit <u>or</u> package <span>(20 or 40 person suite type, respectively)</span>",
                  text: "$600 food & beverage credit <u>or</u> package, based on suite size",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $225/person*",
                },
              ],
            },
            {
              title: "hall of fame suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20+ tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit <u>or</u> package <span>(rent 2 or more conjoining suites to be eligible for package choices)</span>",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $200/person*",
                },
              ],
            },
            {
              title: "legacy suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "18-30 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$800 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      class: "hof",
      // description:
      //   "<span>Hall of Fame Suites</span> are on the Bailey & Galyen Law Suite Level, and feature removable walls to accommodate groups of multiple sizes. Each suite includes a dedicated space for food and beverage in addition to furnishings featuring rich textures. Multiple rows of movie theater style seats outside each suite will keep you comfortable all game long. You can rent a Hall of Fame Suite right here! Just click on the link below and enter SUITE in the offer code box. To view our Hall of Fame Suites on a map, click <a href='https://mktg.mlbstatic.com/rangers/documents/y2023/tex-hof-map.pdf' target='_blank'>here</a>.",
      description:
        "<span>Hall of Fame Suites</span> are on the Bailey & Galyen Law Suite Level and feature removable walls to accommodate groups of multiple sizes up to 500 people. Each suite includes a dedicated space for food and beverage in addition to furnishings featuring rich textures. Multiple rows of movie theater style seats outside each suite will keep you comfortable all game long.",
      // buyButton:
      //   "https://mlb.tickets.com/schedule/?agency=MLB_MPV&orgid=3#/sales_groups;salesGroupId=2505",
      bookButton:
        "https://flex2.seasonshare.com/texasrangers_suites/purchase_seats?purchaseSeatTab=find_games",
      repButton: true,
      // buyButton:
      //   "https://mlb.tickets.com/schedule/?agency=MLB_MPV&orgid=3#/sales_group_code;salesGroupId=2705",
      suites: [
        {
          // title: "<span>lower</span> party suites",
          slider: [
            // require("@/assets/images/SuiteRentals/HOF/hall-of-fame_1.jpg"),
            // require("@/assets/images/SuiteRentals/HOF/hall-of-fame_2.jpg"),
            // require("@/assets/images/SuiteRentals/HOF/hall-of-fame_3.jpg"),
            // require("@/assets/images/SuiteRentals/HOF/hall-of-fame_4.jpg"),
            // require("@/assets/images/SuiteRentals/HOF/hall-of-fame_5.jpg"),
            // require("@/assets/images/SuiteRentals/HOF/hall-of-fame_6.jpg"),
            // require("@/assets/images/SuiteRentals/HOF/hall-of-fame_7.jpg"),
            // require("@/assets/images/SuiteRentals/HOF/hall-of-fame_8.jpg"),
            require("@/assets/images/SuiteRentals/HOFNew/hof_1.jpg"),
            require("@/assets/images/SuiteRentals/HOFNew/hof_2.jpg"),
            require("@/assets/images/SuiteRentals/HOFNew/hof_3.jpg"),
            require("@/assets/images/SuiteRentals/HOFNew/hof_4.jpg"),
            require("@/assets/images/SuiteRentals/HOFNew/hof_5.jpg"),
            require("@/assets/images/SuiteRentals/HOFNew/hof_6.jpg"),
            require("@/assets/images/SuiteRentals/HOFNew/hof_7.jpg"),
          ],
          info: [
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_pin-location.svg"),
              description: "Bailey & Galyen law suite level",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_ticket.svg"),
              description: "20+ tickets",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_dollar-sign.svg"),
              description: "starting at $200/person*",
              legal:
                "*$155 per person with total Hall of Fame Suite buyout (280-500 people)",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue_fork-knife.svg"),
              description: "$600 food & beverage credit",
              legal:
                "Rent two or more conjoining suites and your group is eligible for food & beverage package choices",
            },
            {
              icon: require("@/assets/icons/Benefits/icon_blue-small_dollar-sign.svg"),
              description: "10-person hall of fame suites",
              legal: "$225/person (based on availability)",
            },
          ],
        },
      ],
      accordion: [
        // {
        //   icon: require("@/assets/icons/Benefits/icon_blue-big_pin-location.svg"),
        //   title: "suite location",
        //   description: "See where the Hall of Fame Suites are located",
        //   image: require("@/assets/images/SuiteLocations/map_suite-locations_hof.svg"),
        //   class: "hof",
        // },
        {
          icon: require("@/assets/icons/Benefits/icon_blue-big_ticket.svg"),
          title: "compare suites",
          description: "Find the suite type that’s right for you.",
          class: "hof",
          inside: [
            {
              title: "party suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower & upper concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "40-300 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  // text: "$600 food & beverage credit <u>or</u> package <span>(rent 2 or more conjoining suites to be eligible for package choices)</span>",
                  text: "Food & beverage package",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $150/person*",
                },
              ],
            },
            {
              title: "classic suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20-40 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "private restroom",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit <u>or</u> package, based on suite size",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $225/person*",
                },
              ],
            },
            {
              title: "hall of fame suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20+ tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit <u>or</u> package <span>(rent 2 or more conjoining suites to be eligible for package choices)</span>",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $200/person*",
                },
              ],
            },
            {
              title: "legacy suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "18-30 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$800 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      class: "legacy",
      title: "legacy suite",
      description:
        "Created with interaction and conversation in mind, this suite offers open spaces, fantastic views and incredible amenities that will enhace your experience.<br><br>The center of your suite features a dining area, where a thrilling variety of food and beverage will tempt you before and during the game. Choose from our expansive menu and customize a dining experience that suites your entertainment needs.",
      // bookButton:
      //   "https://flex2.seasonshare.com/texasrangers_suites/purchase_seats?purchaseSeatTab=find_games",
      repButton: true,
      perks: [
        {
          icon: require("@/assets/icons/icon_black_pin_location.svg"),
          text: "lower concourse",
        },
        {
          icon: require("@/assets/icons/icon_black_bell.svg"),
          text: "dedicated suite attendant",
        },
        {
          icon: require("@/assets/icons/icon_black_ticket.svg"),
          text: "15-30 tickets",
        },
        {
          icon: require("@/assets/icons/icon_black_lock.svg"),
          text: "private restroom",
        },
        {
          icon: require("@/assets/icons/icon_black_fork_knife.svg"),
          text: "$800 food & beverage credit per game",
        },
        {
          icon: require("@/assets/icons/icon_black_parking.svg"),
          text: "5 vip reserved parking passes",
        },
      ],
      slider: [
        // require("@/assets/images/SeasonSuites/Legacy/legacy_1.jpg"),
        // require("@/assets/images/SeasonSuites/Legacy/legacy_2.jpg"),
        // require("@/assets/images/SeasonSuites/Legacy/legacy_3.jpg"),
        // require("@/assets/images/SeasonSuites/Legacy/legacy_4.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_1.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_2.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_3.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_4.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_5.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_6.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_7.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_8.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_9.jpg"),
      ],
      accordion: [
        // {
        //   icon: require("@/assets/icons/Benefits/icon_blue-big_pin-location.svg"),
        //   title: "suite location",
        //   description: "See where the Field Suites are located",
        //   image: require("@/assets/images/SuiteLocations/map_suite-locations_legacy.jpg"),
        // },
        {
          icon: require("@/assets/icons/icon_magnifying-glass.svg"),
          title: "compare suites",
          description: "Find the suite type that’s right for you.",
          inside: [
            {
              title: "party suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower & upper concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "40-300 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  // text: "$600 food & beverage credit <u>or</u> package <span>(rent 2 or more conjoining suites to be eligible for package choices)</span>",
                  text: "Food & beverage package",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $150/person*",
                },
              ],
            },
            {
              title: "classic suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20-40 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "private restroom",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit <u>or</u> package, based on suite size",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $225/person*",
                },
              ],
            },
            {
              title: "hall of fame suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20+ tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit <u>or</u> package <span>(rent 2 or more conjoining suites to be eligible for package choices)</span>",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_dollar-sign.svg"),
                  text: "starting at $200/person*",
                },
              ],
            },
            {
              title: "legacy suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "18-30 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$800 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
          ],
        },
      ],
    },
  ];
};
